var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 1L4 8 1 5","stroke":"#BEC4CF","strokeWidth":"2","fill":"none"}));
}

Check.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10"};

module.exports = Check;

Check.default = Check;
